import { removeHttp } from '@/lib/utils';
import { useTranslation } from 'next-i18next';
import { MdEmail, MdPhone, MdPlace, MdWeb } from 'react-icons/md';

export default function CompanyContact({ company }) {
	const { t } = useTranslation('common');
	const contactOptions = [];
	if (company.phone) {
		contactOptions.push({
			icon: MdPhone,
			label: t('contactCard.phone'),
			content: (
				<a
					className="font-semibold text-blue-600 hover:text-blue-700"
					target="_blank"
					rel="noferer noopenner"
					href={`tel:${company.phone}`}
				>
					{company.phone}
				</a>
			),
			value: company.phone,
		});
	}
	if (company.email) {
		contactOptions.push({
			icon: MdEmail,
			label: t('contactCard.email'),
			content: (
				<a
					className="block truncate font-semibold text-blue-600 hover:text-blue-700"
					target="_blank"
					rel="noferer noopenner"
					href={`mailto:${company.email}`}
				>
					{company.email}
				</a>
			),
			value: company.email,
		});
	}
	if (company.address) {
		contactOptions.push({
			icon: MdPlace,
			label: t('contactCard.location'),
			content: (
				<a
					className="font-semibold text-blue-600 hover:text-blue-700"
					target="_blank"
					rel="noferer noopenner"
					href={`https://www.google.com/maps?q=${company.address}`}
				>
					{company.address}
				</a>
			),
			value: company.address,
		});
	}
	if (company.website) {
		company.website = removeHttp(company.website);
		contactOptions.push({
			icon: MdWeb,
			label: t('contactCard.website'),
			content: (
				<a
					className="block truncate font-semibold text-blue-600 hover:text-blue-700"
					target="_blank"
					rel="noferer noopenner"
					href={`https://${company.website}`}
				>
					{company.website}
				</a>
			),
			value: company.website,
		});
	}

	if (contactOptions.length === 0) {
		return null;
	}

	return (
		<section id="contact">
			<div className="grid grid-cols-1 gap-x-8 gap-y-4 lg:grid-cols-3 lg:gap-y-10">
				<div>
					<h2 className="text-2xl font-bold tracking-tight text-gray-900 lg:text-3xl">
						{t('contactCard.title', { company: company.name })}
					</h2>
					<p className="mt-4 leading-7 text-gray-600">
						{t('contactCard.subtitle', { company: company.name })}
					</p>
				</div>
				<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
					{contactOptions.map((option) => (
						<div
							key={option.label}
							className="rounded-2xl bg-gray-50 p-4 lg:p-10"
						>
							<h3 className="text-base font-semibold leading-7 text-gray-900">
								<option.icon className="-mt-1 mr-2 inline-block h-5 w-5" />{' '}
								{option.label}
								<span className="sr-only">: {option.value}</span>
							</h3>
							<dl className="mt-2 space-y-1 text-sm leading-6 text-gray-600">
								<div>
									<dt className="sr-only">
										{option.label}:{company.name}
									</dt>
									<dd>{option.content}</dd>
								</div>
							</dl>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
